import * as Sentry from '@sentry/nextjs';
import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import Error from 'next/error';
import { LayoutType } from '@/Module/Core/Model/Enum';
const ApplicationNotFound = dynamic(() => import('@/Module/Core/Component/ApplicationError/ApplicationNotFound'));
const ApplicationServerError = dynamic(() => import('@/Module/Core/Component/ApplicationError/ApplicationServerError'));
const ErrorPage: NextPage<any> = ({
  statusCode
}) => {
  switch (statusCode) {
    case 404:
      return <ApplicationNotFound />;
    case 500:
    default:
      return <ApplicationServerError />;
  }
};

// @ts-ignore
ErrorPage.layout = LayoutType.ERROR;
ErrorPage.getInitialProps = async contextData => {
  await Sentry.captureUnderscoreErrorException(contextData);

  // const { res, err } = contextData;
  // eslint-disable-next-line no-nested-ternary
  // const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  // return { statusCode };

  return Error.getInitialProps(contextData);
};
export default ErrorPage;